import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import TypeIt from "typeit-react";
import MetaTagsSeo from "../../components/Shared/MetaTagsSeo";
import {
  cardVariants,
  imageContainer,
  imageItem,
} from "../../styles/animationVars";
import "./TalentSandboxPage.scss";
import CertificateMessages from "../../components/TalentSandbox/CertificateMessages";
function TalentSandboxPage() {
  return (
    <>
      {/* meta sections */}
      <MetaTagsSeo
        title="FROI – TALENT SANDBOX™"
        description="FROI’s TALENT SANDBOX™
The 100 Initiative…
Shaping 100 Certified National Experts
in Future-Ready Government Human Capital"
        keywords={[
          "FUTURE READY ORGANIZATION INSTITUTE",
          "Future Ready",
          "Future Ready Organization",
          "Future Ready Government",
          "Future Readiness Standards for Government Human Capital Practices",
          "Human Capital Future Readiness",
          "Future Readiness Index",
          "Government Human Capital Future Readiness Accreditation",
          "Future Readiness Accreditation",
          "Government Human Capital Future Readiness Index",
          "Future Readiness Research & Studies",
          "FROI's Future Ready Government Human Capital Model",
        ].join(", ")}
        OGDescription="FROI Accreditation is not merely a compliance milestone; it is a global declaration of Governmental Human Capital Future Readiness."
        url="https://www.froiglobal.org/"
      />{" "}
      {/* branding section */}
      <motion.section className="froi_section">
        {/* <section className="froi_section"> */}
        <Container>
          <div>
            <TypeIt
              element="h1"
              className="froi_subtitle"
              options={{
                speed: 50,
                waitUntilVisible: true,
                cursor: false,
                lifeLike: true,
              }}
            >
              <span className="marked_word">
                Certified Future-Ready Government Human Capital Expert
              </span>
              ™
              {/* FROI’s TALENT <span className="marked_word">SANDBOX</span>™ */}
            </TypeIt>
          </div>
          <div>
            <TypeIt
              element="h2"
              className="froi_subtitle"
              options={{
                speed: 50,
                waitUntilVisible: true,
                cursor: false,
                lifeLike: true,
              }}
            >
              World’s First International Qualification in Future-Ready
              Government Human Capital
            </TypeIt>
          </div>
          {/* <div>
            <TypeIt
              element="h2"
              className="froi_subtitle"
              options={{
                speed: 30,
                waitUntilVisible: true,
                cursor: false,
                lifeLike: true,
              }}
            >
              <span className="marked_word">
                Certified Future-Ready Government Human Capital Expert
              </span>
              ™
              <br />
              The Global First Prime Certification for Public Sector Human
              Capital
            </TypeIt>
          </div> */}

          <Row className="froi_brand_section">
            <Col lg={6} xs={12}>
              <div className="froi_brand_text">
                <p className="froi_text">
                  Designed exclusively for government HR teams, the Certified{" "}
                  <span className="no-break">Future-Ready</span> Government
                  Human Capital Expert™ program is the world’s premier
                  qualification, transforming public sector HR professionals
                  into <span className="no-break">future-focused</span>{" "}
                  architects of agile talent ecosystems.
                </p>
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <motion.div
                className="froi_brand_img"
                initial={{
                  opacity: 0,
                  x: 80,
                  scale: 0.75,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0,
                  scale: 1,
                }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
              >
                <img
                  src={"./images/TalentSandBox/Certification_logo.png"}
                  alt={"FROI Talent sandbox logo"}
                />
              </motion.div>
            </Col>
          </Row>
        </Container>
      </motion.section>
      {/* Programs section */}
      <section className="froi_section certificates_section">
        <Container>
          <h3 className="marked_word title_h3">
            <strong>Program at a Glance</strong>
          </h3>
          <Row>
            <Col lg={6} xs={12}>
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/Talent_sandbox_page_side_card_1.png"
                  alt="Talent_sandbox_page_side_card_1"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/Talent_sandbox_page_side_card_2.png"
                  alt="Talent_sandbox_page_side_card_2"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/Talent_sandbox_page_side_card_3.png"
                  alt="Talent_sandbox_page_side_card_3"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/Talent_sandbox_page_side_card_4.png"
                  alt="Talent_sandbox_page_side_card_4"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* certificate sections */}
      <section className="froi_section certificates_section">
        <Container>
          <h3 className="marked_word title_h3">
            <strong>Certification Program Highlights</strong>
          </h3>
          <Row>
            <Col lg={6} xs={12}>
              <div className="talent_img">
                {/* <CertificateMessages
                title={"The Credential"}
                description={
                  <>
                    {" "}
                    Grants the globally recognized Certified{" "}
                    <span className="no-break"> Future-Ready</span> Gov Human
                    Capital Expert™.
                  </>
                }
              /> */}

                <motion.img
                  src="./images/TalentSandBox/TALENT_SANDBOX_MESSAGE_1.png"
                  alt="TALENT_SANDOX_MESSAGE_1"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
            <Col lg={6} xs={12}>
              {/* <CertificateMessages
                title="The Methodology"
                description="Utilizes hands-on experiential learning within 
the Talent Sandbox™, bridging advanced future 
sciences with practical public sector application."
              /> */}
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/TALENT_SANDBOX_MESSAGE_4.png"
                  alt="TALENT_SANDOX_MESSAGE"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={6} xs={12}>
              {/* <CertificateMessages
                title="Curriculum"
                description={
                  <>
                    Structured across 5 Core Knowledge Domains that
                    comprehensively define the frontier of{" "}
                    <span className="no-break"> future-ready</span> government
                    HR practices.
                  </>
                }
              /> */}
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/TALENT_SANDBOX_MESSAGE_2.png"
                  alt="TALENT_SANDOX_MESSAGE"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
            <Col lg={6} xs={12}>
              {/* <CertificateMessages
                title="Delivery Mode"
                description="Available exclusively as customized in-house training 
for government entities, comprehensively delivered 
in both English and Arabic."
              /> */}
              <div className="talent_img">
                <motion.img
                  src="./images/TalentSandBox/TALENT_SANDBOX_MESSAGE_3.png"
                  alt="TALENT_SANDOX_MESSAGE"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
          </Row>
          <Row>
            {" "}
            <Col lg={6} xs={12}>
              <div className="talent_img">
                {/* <CertificateMessages
                  title="Applied Expertise"
                  description={
                    <>
                      Qualifies participants through the in-depth mastery of
                      FROI’s 66 technical guidelines and tools, empowering them
                      with the exact knowledge required to successfully
                      establish and operate{" "}
                      <span className="no-break"> future-ready</span> human
                      capital ecosystems.
                    </>
                  }
                /> */}
                <motion.img
                  src="./images/TalentSandBox/TALENT_SANDBOX_MESSAGE_5.png"
                  alt="TALENT_SANDOX_MESSAGE"
                  initial={{ opacity: 0, y: -40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.7,
                    delay: 0.6,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* cards sections */}
      <section className="froi_section cards_section">
        <Container>
          <motion.div
            className="froi-index-cards"
            variants={imageContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{
              //once: true,
              amount: 0.25,
            }}
          >
            <Row>
              <Col lg={4} xs={12}>
                <motion.img
                  variants={imageItem}
                  className="Index_message"
                  src="./images/TalentSandBox/TALENT_SANDOX_card_1.png"
                  alt="TALENT SANDOX card 1"
                />
              </Col>

              <Col lg={4} xs={12}>
                <motion.img
                  variants={imageItem}
                  className="Index_message"
                  src="./images/TalentSandBox/TALENT_SANDOX_card_2.png"
                  alt="TALENT SANDOX card 2"
                />
              </Col>

              <Col lg={4} xs={12}>
                <motion.img
                  variants={imageItem}
                  className="Index_message"
                  src="./images/TalentSandBox/TALENT_SANDOX_card_3.png"
                  alt="TALENT SANDOX card 3"
                />
              </Col>
            </Row>
          </motion.div>
        </Container>
      </section>
    </>
  );
}

export default TalentSandboxPage;
